export default __webpack_public_path__ + "static/media/jsk.bb49ab38.png";